var _module = require('../module');
var _ = require('lodash');
var simpleCypher = require('../../../libs/simple-cypher');
var $ = require('jquery');

require('angular-ui-router');
require('../third-party/angular-slick');
require('../third-party/angular-google-staticmaps');
require('../google-search-autocomplete');
require('../mobile-alerts-banner');
require('../window-height');
require('../../services/listing');
require('../../services/map-modal');
require('../../services/lr-touch');
require('../../services/user');
require('../../services/verify-modal');
require('../../services/login-or-register-modal');
require('../../services/search-filter');
require('../../services/search-results-utils');
require('../../services/listhub');
require('../../services/analytics');
require('../../services/activity-feed');
require('../../services/fullscreen-loading');
require('../../services/fullscreen-carousel');
require('../../services/add-buyer-agent-modal');
require('../../services/buyer-interested-modal');
require('../../services/buyer-force-notify-modal');
require('../../services/error-modal');
require('../../services/firstam');
require('../../filters');
require('../lrphotowall');
require('../../services/analytics');
require('../related-listings');
require('../mortgage-calculator');
require('../countdown-timer');
require('../favorite-btn');
require('../share-btn');
require('../stickyheader');
require('../../services/inactive-listing-modal');
require('../../services/lighapi');
require('./header');

var $profileConfig = require('./profile-config');

_module.requires.push('ui.router', 'slickCarousel', 'wu.staticGmap');

_module.controller('ViewPrivateListingCtrl', [
    '$log',
    '$scope',
    '$http',
    '$location',
    '$q',
    '$state',
    '$stateParams',
    'Listing',
    'SearchFilter',
    '$user',
    '$mapModal',
    '$loginOrRegisterModal',
    '$verifyModal',
    '$addBuyerAgentModal',
    '$buyerInterestedModal',
    '$buyerForceNotifyModal',
    '$errorModal',
    'srUtils',
    '$listhub',
    '$analytics',
    '$activityFeed',
    '$fsloading',
    '$fscarousel',
    '$firstam',
    '$timeout',
    '$inactiveListingModal',
    '$lighapi',

    function ViewPrivateListingCtrl($log, $scope, $http, $location, $q, $state, $stateParams, Listing, SearchFilter, $user, $mapModal, $loginOrRegisterModal, $verifyModal, $addBuyerAgentModal, $buyerInterestedModal, $buyerForceNotifyModal, $errorModal, srUtils, $listhub, $analytics, $activityFeed, $fsloading, $fscarousel, $firstam, $timeout, $inactiveListingModal, $lighapi) {
        $log.debug('view private listing', this);

        var vpl = this;

        vpl.model = {};
        vpl.services = {
            infographicsCustomDot: infographicsCustomDot
        };
        vpl.layout = {
            keywordsLimit: 12,
            showMoreKeywords: false,
            missingBuyerAgent: false
        };
        vpl.events = {
            onHeaderIsSticky: onHeaderIsSticky,
            onHeaderIsntSticky: onHeaderIsntSticky,
            onSlideClick: onSlideClick,
            onAddBuyerAgentClick: onAddBuyerAgentClick,
            onBuyerInterested: onBuyerInterested,
            onForceNotifyBuyer: onForceNotifyBuyer,
            onMapClick: onMapClick
        };

        function getStickyHeaderLinks() {
            vpl.model.stickyHeaderLinks = [
                {
                    label: 'About the Home',
                    id: 'about-the-home',
                    hide: false
                },
                {
                    label: 'Match Score',
                    id: 'match-score',
                    hide: false
                },
                {
                    label: 'Infographics',
                    id: 'infographics',
                    hide: true
                },
                {
                    label: 'Payment Calculator',
                    id: 'payment-calculator',
                    hide: false
                }
            ];
        }

        function getInfographics(report) {
            if(!(report && report.images)) return;

            var types = ['area', 'schools', 'outdoors', 'restaurant'];
            var infographics = types.map(function (type) {
                var val = _.get(report, 'images.' + type);
                if(val && val.default) {
                    return val.default;
                }
                return null;
            });

            vpl.model.infographics = _.compact(infographics);
            if(vpl.model.infographics.length) {
                _.find(vpl.model.stickyHeaderLinks, { label: 'Infographics' }).hide = false;
                appendInfographicsToPhotos();
            }
        }

        function infographicsCustomDot(slick, i) {
            return '<a class="btn btn-link"><img src="' + vpl.model.infographics[i] + '" class="img-responsive" /><div class="overlay"></div></a>';
        }

        function appendInfographicsToPhotos (photos) {
            var abnListingPhotos = (angular.isArray(photos) && photos.length)
                ? photos
                : (_.has(vpl.model, 'listing.photos'))
                    ? vpl.model.listing.photos
                    : [];

            if( !_.get(vpl.model, 'listing.photos', []).length ) {
                abnListingPhotos.push('/images/hero_placeholder_full.png');
            }

            if(angular.isArray(vpl.model.infographics) && vpl.model.infographics.length) {
                abnListingPhotos = abnListingPhotos.filter(function (url) {
                    return vpl.model.infographics.indexOf(url) < 0;
                });
                abnListingPhotos.push.apply(abnListingPhotos, vpl.model.infographics);
            }

            if(vpl.model.listing) {
                vpl.model.listing.photos = abnListingPhotos;
            }
        }

        function getListingState(listing) {
            if(_.get(listing, 'state', '').length) {
                return listing.state;
            } else if(_.has(listing, 'meta.google_geocoder.address_components')){
                var addr_components =  _.get(listing, 'meta.google_geocoder.address_components');
                var stateComp = _.find(addr_components, function (comp) {
                    return _.get(comp, 'types', []).indexOf('administrative_area_level_1') > -1;
                });

                if(stateComp) {
                    return _.get(stateComp, 'short_name');
                } else {
                    return null;
                }
            } else {
                return null;
            }
        }

        function formatListingData(listing) {
            listing.addressSplit = _.get(listing, 'address', '').replace(/^([\w\s\d#.]*)(,)(\s)/i, '$1{{SPLITME}}').split('{{SPLITME}}');
            listing.photos = _.compact(listing.photos);
            listing.days_on_market = srUtils.getDaysOnMarket(listing);
            listing.state = getListingState(listing);
            listing.lat = _.get(listing, 'meta.google_geocoder.geometry.location.lat');
            listing.lon = _.get(listing, 'meta.google_geocoder.geometry.location.lng');
            listing.private = ( _.get(listing, 'listing_status') === 'Off-Market' || _.get(listing, 'listing_lifecycle.status') === 'Off-Market' );

            return listing;
        }

        function setSearchFilterData(buyer, listing) {
            vpl.model.searchFilter = new SearchFilter(_.get(buyer, 'search_filter', {}));
            vpl.model.whyAndWhyNot = vpl.model.searchFilter.whyAndWhyNot(listing, 5);
        }

        function getProfileData() {
            var profiles = _.get($profileConfig, vpl.model.viewType);
            if(profiles && profiles.length) {
                vpl.model.profiles = _.compact(

                    profiles.map(function (profile) {
                        if(profile && profile.path && _.get(vpl.model, profile.path) ) {
                            var shouldDisplay = true;
                            // don't display unverified buyer agent
                            if(profile.path === 'buyer.buyer_agent') {
                                shouldDisplay = !!_.get(vpl, 'model.buyer.buyer_agent.verified');
                                // if not displaying unverified agent, missingBuyerAgent should be true, else false
                                vpl.layout.missingBuyerAgent = !shouldDisplay;
                            }
                            return {
                                shouldDisplay: shouldDisplay,
                                title: profile.title,
                                data: _.get(vpl.model, profile.path)
                            };
                        }
                    })

                );
            }
        }

        function getListingBuyerData(encodedId) {
            if(!encodedId) encodedId = $stateParams.privateListingId;
            $fsloading.show();

            return $http.get('/v1/abn-listing-data/' + encodedId)
                .then(function (response) {
                    if(_.has(response, 'data.data')) {
                        vpl.model.listing = formatListingData( _.get(response, 'data.data.abnListing') );
                        vpl.model.buyer = _.get(response, 'data.data.abnListingBuyer');
                        vpl.model.viewType = _.get(response, 'data.data.viewType');
                        vpl.layout.missingBuyerAgent = ( _.get(vpl, 'model.viewType') === 'buyer' && !_.get(vpl, 'model.buyer.buyer_agent') );
                        setSearchFilterData(vpl.model.buyer, vpl.model.listing);
                        initSlickConfig();
                        getProfileData();
                        getInfographics(_.get(vpl, 'model.listing.report', null));
                    }
                })
                .catch(function getListingBuyerDataError(err) {
                    $log.error('ViewPrivateListingCtrl -> get listing error', err);
                    vpl.model.showListingNotFound = true;
                })
                .finally(function () {
                    $fsloading.hide();
                });
        }

        function onHeaderIsSticky() {
            $timeout(function () {
                vpl.layout.stickyHeader = true;
            }, 0);
        }

        function onHeaderIsntSticky() {
            $timeout(function () {
                vpl.layout.stickyHeader = false;
            }, 0);
        }

        function onMapClick() {
            $mapModal([_.get(vpl, 'model.listing.lat'), _.get(vpl, 'model.listing.lon')]);
        }

        function initSlickConfig() {
            vpl.model.currentSlickIndex = 0;
            vpl.model.slickConfig = {
                method: {},
                event: {
                    afterChange: function (event, slick, currentSlide, nextSlide) {
                        $timeout(function () {
                            vpl.model.currentSlickIndex = currentSlide; // save current index each time
                        });
                    }
                }
            };
        }

        function onSlideClick($index, images) {
            if(vpl.model.listing) {
                $fscarousel(images, $index);
            }
        }

        function getBuyerAgentTrackData(src) {
            return {
                'Address': _.get(vpl, 'model.listing.address'),
                'ABN Listing ID': _.get(vpl, 'model.listing.id'),
                'Benoit User ID': _.get(vpl, 'model.buyer.benoitUserId'),
                'Source': src
            };
        }

        function onAddBuyerAgentClick() {
            var data = {
                id: vpl.model.buyer.benoitUserId,
                showConfirmationModal: true,
                analyticsEventNameSubmit: 'ABN Buyer Agent Info Submit',
                analyticsEventDataSubmit: _.merge(getBuyerAgentTrackData('Your Team Section'), { Source: 'ABN Listing Detail Page' })
            };

            return $addBuyerAgentModal(data).result
                .then(onAddBuyerAgentModalClose);
        }

        function onAddBuyerAgentModalClose(res) {
            $log.debug('AddBuyerAgentModal response', res);
            if(res) {
                updateBuyerAgent(res);
            }
        }

        function updateBuyerAgent(buyerAgent) {
            if(buyerAgent) {
                _.set(vpl, 'model.buyer.buyer_agent', buyerAgent);
                vpl.layout.missingBuyerAgent = false;
                getProfileData();
            }
        }


        function buyerAgentVerifiedCheck() {
            var promise;

            if(_.get(vpl, 'model.buyer.buyer_agent.verified')) {
                promise = $q.when(_.get(vpl, 'model.buyer.buyer_agent'));
            } else {
                var data = {
                    id: vpl.model.buyer.benoitUserId,
                    analyticsEventNameSubmit: 'ABN Buyer Agent Info Submit',
                    analyticsEventDataSubmit: _.merge(getBuyerAgentTrackData('Interested Button'), { Source: 'ABN Listing Detail Page' })
                };

                promise = $addBuyerAgentModal(data).result;
            }

            return $q.when(promise);
        }

        function updateBuyerStatus(interested) {
            var status = (interested) ? 'interested' : 'not interested';
            vpl.model.buyer.status = status;

            var url = '/v1/abn-listing-buyer/' + vpl.model.buyer.id + '/interested';
            var postBody = {
                interested: interested
            };

            return $http.post(url, postBody)
                .then(function (response) {
                    $log.debug('updateBuyerStatus response -> ', response);
                    if(status === 'interested') {
                        return $buyerInterestedModal(vpl.model.profiles);
                    }
                })
                .catch(function (err) {
                    $log.error('updateBuyerStatus error ->', err);
                    return $errorModal('Something went wrong while trying to notify your partners. Please contact support@listreports.com if this problem persists');
                });
        }

        function forceNotifyBuyer() {

            var url = '/v1/abn-listing-buyer/' + vpl.model.buyer.id + '/force-notify';
            var postBody = {
                viewType: vpl.model.viewType
            };

            return $http.post(url, postBody)
                .then(function (response) {
                    $log.debug('forceNotifyBuyer response -> ', response);
                    if(!_.get(vpl, 'model.buyer.meta')) vpl.model.buyer.meta = {};
                    vpl.model.buyer.meta.force_notify = vpl.model.viewType;
                    return $buyerForceNotifyModal(vpl.model.profiles);
                })
                .catch(function (err) {
                    $log.error('forceNotifyBuyer error ->', err);
                    return $errorModal('Something went wrong while trying to notify your buyer. Please contact support@listreports.com if this problem persists');
                });
        }

        function onBuyerInterested(interested) {
            buyerAgentVerifiedCheck()
            .then(function (buyerAgentResponse) {
                $log.debug('onBuyerInterestedClick -> buyer agent verified', buyerAgentResponse);
                onAddBuyerAgentModalClose(buyerAgentResponse);
            })
            .catch(function (err) {
                $log.debug('onBuyerInterestedClick -> buyer agent verification dismissed', err);
            })
            .finally(function () {
                // we update the buyer status
                // in the finally block to account
                // for cases where the buyer has no agent
                // and the add buyer agent modal is dismissed

                updateBuyerStatus(interested);
            });
        }

        function onForceNotifyBuyer() {
            buyerAgentVerifiedCheck()
            .then(function (buyerAgentResponse) {
                $log.debug('onForceNotifyBuyer -> buyer agent verified', buyerAgentResponse);
                onAddBuyerAgentModalClose(buyerAgentResponse);
            })
            .catch(function (err) {
                $log.debug('onForceNotifyBuyer -> buyer agent verification dismissed', err);
            })
            .finally(function () {
                forceNotifyBuyer();
            });
        }

        function init() {
            getListingBuyerData();
            getStickyHeaderLinks();
        }

        init();
    }
]);

_module.component('viewPrivateListing', {
    controllerAs: 'vpl',
    controller: 'ViewPrivateListingCtrl',
    template: require('./index.html')
});
